<template>
    <div>
        <div class="mt-3 row">
            <div class="col-md-10 offset-md-1">
                <h4 style="font-weight:100" class="font-en mt-0 mb-0">
                    <b-link
                        :to="{
                            name: 'Teaching record'
                        }"
                        class="mr-2"
                    >
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    </b-link>
                    Edit Teaching records
                </h4>
                <b-card class="mt-3">
                    <b-form @submit.prevent="sendFormEditTeaching" class="mt-0">
                        <b-row class="my-3">
                            <b-col sm="2">
                                <label style="color:#66615b;" class="font-en"><i class="fa fa-caret-right" aria-hidden="true"></i>Term year <span class="text-danger">*</span></label>
                            </b-col>
                            <b-col sm="10">
                                <b-form-select @change="selectSectionTerm"  v-model="formData.term" :options="Optionterm"></b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="2">
                                <label style="color:#66615b;" class="font-en"><i class="fa fa-caret-right" aria-hidden="true"></i>Course <span class="text-danger">*</span></label>
                            </b-col>
                            <b-col sm="10">
                                <b-form-group description="Please contact : Tel. +66 (0) 2700 5000 Ext. 4205 , 4206 , 4208 If you could not find needed course.">
                                    <b-form-select @change="selectSection" v-model="formData.course" :options="codes"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="my-3">
                            <b-col sm="2">
                                <label style="color:#66615b;" class="font-en"><i class="fa fa-caret-right" aria-hidden="true"></i>Section <span class="text-danger">*</span></label>
                            </b-col>
                            <b-col sm="10">
                                <b-form-select v-model="formData.section" :options="OptionSelection"></b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-3">
                            <b-col sm="2">
                                <label style="color:#66615b;" class="font-en"><i class="fa fa-caret-right" aria-hidden="true"></i>Teaching period <span class="text-danger">*</span></label>
                            </b-col>
                            <b-col sm="10">
                                <b-form-select v-model="formData.week" :options="round"></b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-3">
                            <b-col sm="2">
                                <label style="color:#66615b;" class="font-en"><i class="fa fa-caret-right" aria-hidden="true"></i>Upload <span class="text-danger">*</span></label>
                            </b-col>
                            <b-col sm="10">
                                <!--  or .zip. if you have multiple files, please zip them and upload. -->
                                <b-form-group v-if="upload_file !== ''" description="Teaching record file can be screenshots of meeting logs or meeting screens. File types that can be uploaded are .pdf">
                                    <b-form-file
                                        @change="sendFormEditTeachingFile"
                                        v-model="formData.file"
                                        :placeholder="upload_file.split('/teaching_notes_file/')[1]"
                                        drop-placeholder="Drop file here..."
                                        accept="application/pdf"
                                    ></b-form-file>
                                    <div class="mt-3">Selected file: <span v-html="msgFile"></span></div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="my-3">
                            <b-col sm="2"></b-col>
                            <b-col sm="10">
                                <b-button
                                    :disabled="!isForm"
                                    type="submit" 
                                    size="sm"
                                    block variant="success"
                                ><i class="fa fa-paper-plane" aria-hidden="true"></i>Submit</b-button>
                                <!-- <b-alert v-if="msgError !== ''"  class="mt-2" show variant="warning">Error : {{ msgError }} </b-alert> -->
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .font-thai{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .font-en{ font-family: 'Rubik', sans-serif; }
</style>

<script>
    import datePicker from 'vue-bootstrap-datetimepicker'
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
    const formTeaching = {
        term:'',
        course:'',
        section:'',
        week:'',
        file:null,
    }
    export default {
        components: {
            datePicker
        },
        data() {
            return {
                boolFile:true,
                msgFile:'',
                msgError:'',
                dataCode:[],
                codes:[],
                optionsPicker: {
                    format: 'YYYY-MM-DD h:mm:ss',
                    useCurrent: false,
                },
                OptionValue:[],
                OptionSelection:[{value: '', text: 'Please select section' , disabled: true}],
                round:[],
                formData: Object.assign({}, formTeaching),
                Optionterm:[],
                OptionValueTerm:[],
                closeCode:true
            }
        },
        props: {
            id: { type: Number, default: 0 },
            upload_file:{ type: String, default: '' },
            term: { type: String, default: '' },
            course: { type: String, default: '' },
            section: { type: String, default: '' },
            week: { type: Number, default: 0 },
        },
        computed: {
            isForm(){
                return this.formData.course !== '' && this.formData.section !== '' && this.formData.week !== '' && this.boolFile;
            },
        },
        mounted(){ 
            this.callListPeriods()
            this.loadValue()
            this.callTerm()
            this.getFile()
        },
        methods: {
            async callListPeriods(){
                const res = await this.$http.get('/teaching/note_period/')
                this.round = res.data.map( item => {
                    return {
                        'value':item.id,
                        'text':item.period+' ( '+item.type_around+' )',
                    }
                })
                this.round.sort(function(a, b) {
                    var nameA = a.text.toUpperCase(); // ignore upper and lowercase
                    var nameB = b.text.toUpperCase(); // ignore upper and lowercase
                    if (nameA < nameB) { return -1; }
                    if (nameA > nameB) { return 1; }
                    // names must be equal
                    return 0;
                });
                this.round.push({value: '', text: 'Please select teaching period' , disabled: true})
            },
            async callTerm(){
                this.Optionterm = []
                try {
                    const res = await this.$http.get('/teaching/course/term_year/')
                    // console.log(res.data)
                    this.Optionterm = res.data.map(item => {
                        return { 
                            'value': `${item.term_year}`,
                            'text': `${item.term_year}`,
                        }
                    })
                    this.Optionterm.sort(function(a, b) {
                        var nameA = a.value.toUpperCase();
                        var nameB = b.value.toUpperCase();
                        if (nameA > nameB) { return -1; }
                        if (nameA < nameB) { return 1; }
                        return 0;
                    });
                    this.Optionterm.push({value: '', text: 'Please select Term year' , disabled: true})
                } catch (error) {}
            },
            async callCode(TermYearValue){
                this.codes = []
                this.dataCode = []
                try {
                    const res = await this.$http.get(`/teaching/course/?term_year=${TermYearValue}`)
                    if(res.status === 200){
                        // code
                        this.codes = res.data.map(item => {
                            return { 
                                'value': `${item.subject}`,
                                'text': `${item.subject}`,
                            }
                        })
                        // all data
                        this.dataCode = res.data.map(itemData => {
                            return { 
                                'section': itemData.section,
                                'subject': `${itemData.subject}`,
                                'term_year': itemData.term_year[0],
                            }
                        })
                        this.selectSection()
                        //
                        this.codes.sort(function(a, b) {
                            var nameA = a.value.toUpperCase(); // ignore upper and lowercase
                            var nameB = b.value.toUpperCase(); // ignore upper and lowercase
                            if (nameA < nameB) { return -1; }
                            if (nameA > nameB) { return 1; }
                            // names must be equal
                            return 0;
                        });
                        this.codes.push({value: '', text: 'Please select course' , disabled: true})
                    }
                } catch (error) {}
            },
            getFile(){
                if (this.upload_file.length !== 0) {}
            },
            loadValue(){
                this.formData.term = this.term
                this.formData.course = this.course
                this.formData.section = this.section
                this.formData.week = this.week
                this.callCode(this.formData.term)
            },
            checkFileType(valFile){
                if(valFile !== null){
                    if(valFile.type !== 'application/pdf'){
                        this.msgFile = '<span class="text-danger">.pdf file only.</span>'
                        return false
                    }else{ 
                        this.msgFile = `<span class="text-success">${valFile.name}</span>`
                        return true
                    }
                }else{
                    return null
                }
            },
            async sendFormEditTeaching(){
                const sendData = new FormData()
                sendData.append('term', this.formData.term)
                sendData.append('course', this.formData.course)
                sendData.append('section', this.formData.section)
                sendData.append('around', this.formData.week)
                try {
                    const response = await this.$http.patch(`/teaching/note/${this.id}/edit/`,
                        sendData,
                        {
                            headers: { 'Content-Type': 'multipart/form-data' }
                        }
                    )
                    if(response.status === 200){
                        this.$router.replace('/teaching')
                    }
                } catch (error) {
                    this.msgError = error
                }
            },
            async sendFormEditTeachingFile(event){
                const sendData = new FormData()
                sendData.append('upload_file', event.target.files[0])
                // console.log(event.target.files[0].type)
                this.boolFile = this.checkFileType(event.target.files[0])
                if(this.boolFile){
                    try {
                        const response = await this.$http.patch(`/teaching/note/${this.id}/reupload/`,
                            sendData,
                            {
                                headers: { 'Content-Type': 'multipart/form-data' }
                            }
                        )
                        if(response.status !== 200){
                            throw { response }
                        }
                    } catch (error) {
                        // event.target.files[0] = null
                        this.msgError = error
                    }
                }
            },
            selectSectionTerm(){
                this.closeCode = true
                this.formData.course = ''
                this.codes = []
                this.OptionValueTerm = []
                // this.OptionValueTerm = this.dataCode.filter( item => {
                //     return item.term_year === this.formData.term
                // }).map(itemData => {
                //     return { 
                //         'value': itemData.subject,
                //         'text': itemData.subject,
                //     }
                // })
                // this.codes.push(this.OptionValueTerm[0].value,{value: '', text: 'Please select Course' , disabled: true})
                // this.codes = this.OptionValueTerm
                this.callCode(this.formData.term)
                this.codes.push({value: '', text: 'Please select Course' , disabled: true})
                this.closeCode = false
            },
            selectSection(){
                this.OptionValue = []
                this.OptionSelection = []
                this.OptionValue = this.dataCode.filter( item => {
                    return item.subject === this.formData.course
                }).map(itemData => {
                    return { 
                        'value': itemData.section,
                    }
                })
                // console.log(this.OptionValue)
                this.OptionSelection =  this.OptionValue[0].value.map(itemOption => {
                    return { 
                        'value': itemOption,
                        'text': `${itemOption}`,
                    }
                })
                // .sort((a, b) =>{ return a.value - b.value; });
                this.OptionSelection.sort((a, b) =>{ return a.value - b.value; }).push({value: '', text: 'Please select section' , disabled: true})
            }
        }
    }
</script>